import React from "react";
import {Container, Image, Grid} from "semantic-ui-react";
import footerPicture from '../pictures/footerPicture.jpg'
import '../style.css'


//Uses static picture for UH logo
export default function Footer() {
    return (
        <>
        <div className='FooterStyle'>
            <Container className='containerStyle'>
        <Grid className='center aligned'>
                <Image className='imageStyle'  src={footerPicture} />

            </Grid>
            </Container>
        </div>

        </>
    )
}
